import axios from 'axios'
import Authenticate from '@/service/Authenticate'

export default class Request {

  static existToken () {
    let user = Authenticate.currentUser()
    if (user && user.access_token) {
      return true
    } else {
      return false
    }
  }

  static httphost (auth) {
  // static httphost () {
    let baseUri = '/'
    if (document.domain === 'localhost') {
      baseUri = 'http://localhost:9000/'
    }

    if (auth) {
      let user = Authenticate.currentUser()
      baseUri += 'group/' + user.contract_id
    }
    console.log(baseUri)

    return baseUri
  }

  static instance (auth) {
    let baseUri = '/'
    if (document.domain === 'localhost') {
      baseUri = 'http://localhost:9000/'
    }

    let user = Authenticate.currentUser()

    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    }

    if (auth) baseUri += 'group/' + user.contract_id
    if (user) headers.Authorization = 'Bearer ' + user.access_token

    return axios.create({
      baseURL: baseUri,
      headers: headers
    })
  }

  // application/x-www-form-urlencodedなしパターン
  static create (auth) {
    let baseUri = '/'
    if (document.domain === 'localhost') {
      baseUri = 'http://localhost:9000/'
    }

    let user = Authenticate.currentUser()

    let headers = {}

    if (auth) baseUri += 'group/' + user.contract_id
    if (user) headers.Authorization = 'Bearer ' + user.access_token

    return axios.create({
      baseURL: baseUri,
      headers: headers
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/Request.js